import React, { useState, useEffect, useContext } from 'react';
import { Paper, TableContainer, TableBody, TableCell, TableHead, TableRow, Table, Typography, Stack, Button, IconButton, Box } from '@mui/material';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import SwapHorizRoundedIcon from '@mui/icons-material/SwapHorizRounded';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { isEmpty, isUndefined } from 'lodash';
import moment from 'moment';
import { DataContext } from '../../../context/DataContext';
import { getToken } from '../../../api/Account';
import { isAccess, simpleMessage } from '../../../helpers/Helpers';
import NoData from '../../../components/NoData';
import { PaginationComponent } from '../../../components/PaginationComponent';
import { getGastosAsync } from '../../../api/Contabilidad';
import { monoFont } from '../../../theme';

import MediumModal from '../../../components/modals/MediumModal';
import DetalleGasto from './DetalleGasto';
import AddTrasnferencia from './AddTrasnferencia';
import AddGasto from './AddGasto';

const money = (n) => new Intl.NumberFormat('es-NI', { style: 'currency', currency: 'NIO' }).format(n);

const GastosList = () => {
	var date = new Date();
	const [fechaDesde] = useState(new Date(date.getFullYear(), date.getMonth(), 1));
	const [fechaHasta] = useState(date);

	const [gastoList, setgastoList] = useState([]);
	const [selectedGasto, setSelectedGasto] = useState([]);
	const [localReload, setLocalReload] = useState(false);

	const [showModal, setShowModal] = useState(false);
	const [printModal, setPrintModal] = useState(false);

	const [sumGastos, setSumGastos] = useState(0);
	const [isTrasnf, setIsTrasnsf] = useState(false);

	const { setIsLoading, setIsUnautorized, access, selectedSucursal } = useContext(DataContext);

	const token = getToken();

	useEffect(() => {
		if (selectedSucursal === 0 || isUndefined(selectedSucursal)) {
			return;
		}
		getGastos(selectedSucursal);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedSucursal, localReload]);

	const [currentPage, setCurrentPage] = useState(1);
	const [itemsperPage] = useState(10);
	const indexLast = currentPage * itemsperPage;
	const indexFirst = indexLast - itemsperPage;
	const currentItem = gastoList.slice(indexFirst, indexLast);
	const paginate = (pageNumber) => setCurrentPage(pageNumber);

	const getGastos = async (sucursal) => {
		setIsLoading(true);
		const data = {
			desde: moment(fechaDesde).format('YYYY-MM-DD').toString(),
			hasta: moment(fechaHasta).format('YYYY-MM-DD').toString(),
			sucursalId: sucursal
		};
		const result = await getGastosAsync(token, data);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}
		setIsLoading(false);
		setgastoList(result.data.result);

		let gastos = 0;
		result.data.result.map((item) => (gastos += item.entradas));
		setSumGastos(gastos);
	};

	const addMovment = (value) => {
		setIsTrasnsf(value);
		setShowModal(true);
	};

	return (
		<div>
			<Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems={{ xs: 'stretch', sm: 'center' }} spacing={1.5} sx={{ marginBottom: '18px' }}>
				<Paper sx={{ display: 'flex', alignItems: 'center', gap: '12px', padding: '10px 16px' }}>
					<Typography sx={{ fontSize: 12.5, color: 'text.secondary', fontWeight: 500 }}>Total de gastos del mes</Typography>
					<Typography sx={{ fontFamily: monoFont, fontSize: 17, fontWeight: 600, color: 'error.main' }}>{money(sumGastos)}</Typography>
				</Paper>

				{isAccess(access, 'CAJA CREATE') ? (
					<Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
						<Button onClick={() => addMovment(true)} startIcon={<SwapHorizRoundedIcon />} variant="outlined">
							Transferencia
						</Button>
						<Button onClick={() => addMovment(false)} startIcon={<AddRoundedIcon />} variant="contained" color="primary">
							Agregar gasto
						</Button>
					</Stack>
				) : null}
			</Stack>

			{isEmpty(currentItem) ? (
				<NoData />
			) : (
				<Paper sx={{ overflow: 'hidden' }}>
					<TableContainer sx={{ overflowX: 'auto' }}>
						<Table size="small" sx={{ minWidth: 960 }}>
							<TableHead>
								<TableRow>
									<TableCell>Fecha</TableCell>
									<TableCell>Descripción</TableCell>
									<TableCell align="right">Monto</TableCell>
									<TableCell>Cuenta salida</TableCell>
									<TableCell>Beneficiario</TableCell>
									<TableCell>Realizado por</TableCell>
									<TableCell align="center">Ver</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{currentItem.map((row) => (
									<TableRow key={row.id}>
										<TableCell sx={{ fontFamily: monoFont, fontSize: 11.5 }}>{moment(row.fecha).format('L')}</TableCell>
										<TableCell sx={{ fontSize: 12.5, fontWeight: 500 }}>{row.description}</TableCell>
										<TableCell align="right" sx={{ fontFamily: monoFont, fontWeight: 600, color: 'error.main' }}>
											{money(row.entradas)}
										</TableCell>
										<TableCell sx={{ fontSize: 12 }}>{row.payWith}</TableCell>
										<TableCell sx={{ fontSize: 12 }}>{row.beneficiario}</TableCell>
										<TableCell sx={{ fontSize: 12 }}>{`${row.realizadoPor.split(' ')[0]}  ${row.realizadoPor.split(' ')[1]}`}</TableCell>
										<TableCell align="center">
											<IconButton
												size="small"
												onClick={() => {
													setSelectedGasto(row);
													setPrintModal(true);
												}}
											>
												<OpenInNewRoundedIcon sx={{ fontSize: 17 }} />
											</IconButton>
										</TableCell>
									</TableRow>
								))}
							</TableBody>
						</Table>
					</TableContainer>

					<Box sx={{ padding: '10px 20px 14px' }}>
						<PaginationComponent data={gastoList} paginate={paginate} itemsperPage={itemsperPage} />
					</Box>
				</Paper>
			)}

			<MediumModal titulo={isTrasnf ? 'Trasnferir Efectivo Entre Cuentas' : 'Salida de Efectivo'} isVisible={showModal} setVisible={setShowModal}>
				{isTrasnf ? (
					<AddTrasnferencia setShowModal={setShowModal} localReload={localReload} setLocalReload={setLocalReload} selectedSucursal={selectedSucursal} />
				) : (
					<AddGasto setShowModal={setShowModal} localReload={localReload} setLocalReload={setLocalReload} selectedSucursal={selectedSucursal} />
				)}
			</MediumModal>

			<MediumModal titulo={'Detalle Recibo'} isVisible={printModal} setVisible={setPrintModal}>
				<DetalleGasto setShowModal={setShowModal} gasto={selectedGasto} />
			</MediumModal>
		</div>
	);
};

export default GastosList;
